const showModal = ref(false)

const showRenewalTooCloseErrorModal = () => {
  showModal.value = true
}

const hideRenewalTooCloseErrorModal = () => {
  showModal.value = false
}

export const useRenewalTooCloseErrorModal = () => {
  return {
    showModal: readonly(showModal),
    showErrorModal: showRenewalTooCloseErrorModal,
    hideModal: hideRenewalTooCloseErrorModal
  }
}
